<template>
  <v-container fluid>
    <v-row>
      <!-- Select All -->
      <v-col cols="6" v-if="!loading" class="select">
        <v-checkbox
          @change="selectAllColumns"
          v-model="selectAll"
          label="Select All"
        >
          Select all
        </v-checkbox>
      </v-col>

      <!-- Save Button -->
      <v-col cols="6" v-if="!loading" class="save-btn">
        <v-btn
          color="black darken-1 white--text"
          class="custom-button"
          @click="saveChangeStatus"
        >
          Save
        </v-btn>
      </v-col>

      <!-- Table -->
      <v-col>
        <v-data-table
          hide-default-footer
          item-key="id"
          :items-per-page="-1"
          :headers="careerColumnsHeaders"
          :loading="loading"
          :items="careerColumnsNames"
          class="capitalize"
        >
          <!-- Select Checkbox -->
          <template v-slot:[`item.select`]="{ item }">
            <v-checkbox v-model="selectItem" @change="select" :value="item" />
          </template>

          <!-- Actions -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small @click="editCareerColumn(item)">
              mdi-pencil
            </v-icon>
          </template>

          <!-- Edit Dialog -->
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog v-model="editCareerColumnDialog" max-width="850px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Edit Career Column</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form ref="careerColumnsForm">
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="editedCareerColumn.displayName"
                              label="Name"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="red darken-1"
                      text
                      class="custom-button"
                      @click="closeCareerDialog"
                    >
                      Cancel
                    </v-btn>

                    <v-btn
                      color="blue darken-1 white--text"
                      class="custom-button"
                      @click="submitData"
                      :disabled="!editedCareerColumn.displayName"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
          class="custom-button"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CareerColumn from "../../models/careerColumnsNames";

export default {
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      selectItem: [],
      selectAll: false,
      loading: false,
      editedCareerColumn: new CareerColumn(),
      editCareerColumnDialog: false,
      careerColumnsHeaders: [
        { text: "", align: "start", sortable: false, value: "select" },
        { text: "Name", align: "start", sortable: false, value: "displayName" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  async mounted() {
    await this.loadCareerColumnsNames();
    this.loadCareerColumnsSelected();
  },

  computed: {
    ...mapGetters("careers", ["careerColumnsNames"]),
  },

  methods: {
    async loadCareerColumnsNames() {
      await this.$store.dispatch("careers/loadCareerColumnsNames");
    },

    loadCareerColumnsSelected() {
      const activeColumns = this.careerColumnsNames.filter((a) => a.isActive);
      this.selectItem = activeColumns;
      this.selectAll =
        this.careerColumnsNames.length === activeColumns.length;
    },

    select() {
      this.selectAll =
        this.selectItem.length === this.careerColumnsNames.length;
    },

    selectAllColumns() {
      this.selectItem = this.selectAll ? this.careerColumnsNames : [];
    },

    editCareerColumn(item) {
      this.editCareerColumnDialog = true;
      this.editedCareerColumn = item;
    },

    async submitData() {
      this.snackbar = true;
      try {
        await this.$store.dispatch(
          "careers/editCareerColumnName",
          this.editedCareerColumn
        );
        this.snackbarText = "Data updated successfully";
      } catch (error) {
        this.snackbarText = error.message || error;
      } finally {
        this.closeCareerDialog();
      }
    },

    async saveChangeStatus() {
      this.snackbar = true;
      try {
        await this.$store.dispatch(
          "careers/careerColumnsChangeStatus",
          this.selectItem
        );
        this.snackbarText = "Data updated successfully";
      } catch (error) {
        this.snackbarText = error.message || error;
      }
    },

    closeCareerDialog() {
      this.editCareerColumnDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.save-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.v-data-table {
  font-size: large;
  color: black;
}
.v-input input {
  text-transform: capitalize;
}
.disabled-name {
  pointer-events: none;
  opacity: 0.8;
}
</style>